import { useTranslation } from 'react-i18next'

import { RequestSummaryLegend } from '@reveni-io/reveni-ui'

import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'

import { previewConfig } from './constants'
import { getRequestSummaryMessage } from './helpers'
import * as Styles from './styles'

const RequestSummaryPreview = ({ activeRequestSummary, customCopies, lang, isActive }) => {
  const { t } = useTranslation()
  const copies = isActive ? customCopies : {}
  const message = getRequestSummaryMessage(activeRequestSummary, copies, lang)
  const { titleKey, methodNameKey, instant, Icon } = previewConfig[activeRequestSummary]

  return (
    <Styles.Container>
      <WhiteLabelThemeProvider>
        <Styles.PreviewContent>
          <RequestSummaryLegend
            title={t(titleKey)}
            description={message}
            instant={instant}
            methodName={methodNameKey ? t(methodNameKey) : ''}
            methodIcon={<Icon size={20} />}
          />
        </Styles.PreviewContent>
      </WhiteLabelThemeProvider>
    </Styles.Container>
  )
}

export default RequestSummaryPreview
